import HttpClient from "./http-client";
import { getApiUrl, getCurrentLanguageId } from "./common";

// name -> value map, matching /api/clientresource which returns a JSON object keyed by resource name.
type ResourceMap = Record<string, string>;

export default class StringLocalizer{
    private resources: ResourceMap = {};

    private defaultFallbackResources: ResourceMap = {
        Close: "Close",
        Warning: "Warning",
        AjaxCallFailGeneralMessage: "We are sorry, action failed. Please try again later.",
    };

    constructor(){
    }

    public async init(): Promise<void>{
        await this.loadResources();
    }

    public get(name: string): string {
        return this.resources?.[name] ?? this.defaultFallbackResources[name] ?? `Missing.${name}`;
    }

    private async loadResources(): Promise<void> {
        const langId = getCurrentLanguageId();
        const response = await new HttpClient().fetch(`${getApiUrl()}/clientresource?t=${getCurrentLanguageId()}`,  {
            headers: {
                'Current-Language-Id': langId
            }
        }, (_) => {});

        if(response && response.ok) {
            this.resources = await response.json() as ResourceMap;
        }
    }
}
